import React, { useState, useEffect } from "react";
import { Bar } from "react-chartjs-2";
import ColorList from "../../../../lib/ColorList";
import { getReports } from "../../../../actions/appointment";


const DoctorChart = ({ dates }) => {
    const [doctor, setDoctor] = useState({
        colors: [],
        doctors: [],
        payments: []
    })

    const getDoctorsReports = () => {
        getReports(`doctor&from=${dates?.from}&to=${dates?.to}&dtype=${dates?.dateType}`)
            .then((res) => {
                if (res?.status) {
                    if (res?.data.length > 0) {
                        let colors = ColorList(res.data.length);
                        let keys = []
                        let values = []
                        res.data.forEach(item => { 
                            keys.push(item?._id?.name);
                            values.push(item?.totalConsultationFee)
                        })                       
                        setDoctor({ colors: colors, doctors: keys, payments: values })
                    }
                }
            })
            .catch(error => {
                console.log("error.......:)", error);
            });
    }

    useEffect(() => {
        getDoctorsReports();
    }, [dates])


    // const options = {
    //     responsive: true,
    //     plugins: {
    //         legend: {
    //             position: "top",
    //         },
    //         title: {
    //             display: true,
    //             text: "Chart.js Line Chart",
    //         },
    //     },
    // };

    const data = {
        labels: doctor.doctors,
        datasets: [
            {
                label: "Highest Earings",
                data: doctor.payments,
                // borderColor: doctor.colors,
                backgroundColor: doctor.colors,
                hoverBackgroundColor: doctor.colors
            },
        ],
    };
    return <Bar data={data} />;
    // options = { options }
};
export default DoctorChart;
